import {Action} from '@ngrx/store';
import {Role} from "../../../../../core";

export enum RolesActionTypes {
  LOAD_REQUEST = '[ROLES] Load Request',
  LOAD_FAILURE = '[ROLES] Load Failure',
  LOAD_SUCCESS = '[ROLES] Load Success',
}

// load
export class RolesLoadRequestAction implements Action {
  readonly type = RolesActionTypes.LOAD_REQUEST;
}

export class RolesLoadFailureAction implements Action {
  readonly type = RolesActionTypes.LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class RolesLoadSuccessAction implements Action {
  readonly type = RolesActionTypes.LOAD_SUCCESS;

  constructor(public payload: { items: Role[] }) {
  }
}

// actions

export type RolesActions =
  | RolesLoadRequestAction
  | RolesLoadFailureAction
  | RolesLoadSuccessAction;
